import React from 'react';
import { formatCurrency } from '../../../lib/helpers/formatters';

const TotalTrSpecialJobs = ({
  totals = {},
  stickyInfo = [],
  children = [],
}) => {
  const {
    totalExtraShare = 0,
    totalSignalmanShare = 0,
    totalEstimate = 0,
    totalCommercialShare = 0,
    totalCommercial2Share = 0,
    totalCommercial3Share = 0,
  } = totals;

  const cells = [
    '-',
    '-',
    '-',
    '-',
    '-',
    formatCurrency(totalEstimate),
    '-',
    formatCurrency(totalSignalmanShare),
    '-',
    formatCurrency(totalExtraShare),
    '-',
    '-',
    formatCurrency(totalCommercialShare),
    '-',
    '-',
    formatCurrency(totalCommercial2Share),
    '-',
    '-',
    formatCurrency(totalCommercial3Share),
    '-',
  ];

  return (
    <tr className="summary-tr">
      {children.map((child, idx) => {
        const isSticky = child?.props?.sticky;
        const style = stickyInfo?.[idx]?.style || {};
        return (
          <td
            key={idx}
            className={isSticky ? 'sticky' : undefined}
            style={isSticky ? style : undefined}
          >
            {cells[idx] !== undefined ? cells[idx] : '-'}
          </td>
        );
      })}
    </tr>
  );
};

export default TotalTrSpecialJobs;
